export default __webpack_public_path__ + "static/media/02.b9cfcc60.svg";